import { Text } from 'app/design/primitives/text';
import type React from 'react';

export const ResponsiveSectionTitle = ({ children, isLargeUI }: { children: React.ReactNode; isLargeUI: boolean }) => (
  <Text fontWeight="700" textAlign={isLargeUI ? 'left' : 'center'} variant={isLargeUI ? 'bodyBase' : 'bodyLarge'}>
    {children}
  </Text>
);
